"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  meetings: {
    mediaSettings: {
      sendAudio: true,
      sendVideo: true,
      receiveAudio: true,
      receiveVideo: true,
      pstn: false,
      sendShare: false,
      receiveShare: false
    },
    reconnection: {
      enabled: true,
      detection: true,
      retry: {
        times: 2,
        backOff: {
          start: 1000,
          rate: 2
        }
      }
    }
  }
};
//# sourceMappingURL=config.js.map
